import React, { useState, useContext, useEffect } from 'react'
import { connect } from 'react-redux';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import ListGroup from 'react-bootstrap/ListGroup';
import Button from 'react-bootstrap/Button';
import { Link } from 'react-router-dom';
import { ObjModal } from '../../../../contexts';
import AddLoan from '../../../Modals/Loan/add';
import DeleteLoan from '../../../Modals/Loan/delete';
import { FaRegTrashAlt } from 'react-icons/fa';

import { styled } from '@mui/material/styles';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import KeyboardArrowRightSharpIcon from '@mui/icons-material/KeyboardArrowRightSharp';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import { formatShorthand } from '../../../../common/utils';
import { removeLoan } from '../../../../common/api';
import { toast } from 'react-toastify';


const Loans = ( { aid, uid, settings } ) => {
    const { obj, openModal, closeModal, setModal } = useContext( ObjModal );
    const [ expanded, setExpanded ] = useState( false );

    useEffect( () => {
        setExpanded( obj.loans.length > 0 );
    }, [ obj.loans ] );

    const trash = async ( laid, lid ) => {
        const removed = await removeLoan( laid, uid, lid );
        if ( removed.length ) {
            toast.success( `Your loan has been deleted`, { theme: 'dark' } );
            // window.location.reload( false );
        }
    };

    const handleModal = ( t, lid, name ) => {
        let shouldOpen = true;

        switch ( t ) {
            case 'loan':
                setModal( <AddLoan close={closeModal} /> ); 
                break;

            case 'delete':
                setModal( <DeleteLoan close={closeModal} lid={lid} name={name} /> );
                break;

            default:
                console.log( 'Unknown modal type: ' + t );
                shouldOpen = false;
        }

        if ( shouldOpen ) {
            openModal();
        }
    }

    const AccordionSummary = styled( ( props ) => (
        <MuiAccordionSummary expandIcon={<KeyboardArrowRightSharpIcon sx={{ fontSize: '0.9rem' }} />} {...props} />
    ) ) ( ( { theme } ) => ( {
        backgroundColor:
          theme.palette.mode === 'dark'
            ? 'rgba(255, 255, 255, .05)'
            : 'rgba(0, 0, 0, .03)',
        flexDirection: 'row-reverse',
        '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
            transform: 'rotate(90deg)',
        },
        '& .MuiAccordionSummary-content': {
            marginLeft: theme.spacing(1),
        },
    } ) );

    return (
        <Container fluid className='p-0'>
            <Accordion expanded={expanded}>
                <AccordionSummary expandIcon={<KeyboardArrowRightSharpIcon onClick={ () => setExpanded( !expanded ) } />}>
                    <Row className='align-items-center w-100'>
                        <Col><Typography>Loans ({obj.loans.length})</Typography></Col>
                        <Col xs='auto' className='p-0'><Button variant='outline-primary' size='sm' onClick={ () => handleModal( 'loan' ) }>+ Add</Button></Col>
                    </Row>
                </AccordionSummary>
                <AccordionDetails>
                    <ListGroup variant='flush' className='overflow-scroll' style={ { maxHeight: '400px' } }>
                    {
                        obj.loans.map( l => {
                            return (
                                <ListGroup.Item key={l.id}>
                                    <Row className='align-items-center'>
                                        <Col xs='auto' className='tf-sidebar-obj-value'>
                                        {
                                            ( l.status === 'Pre-Approved' && ( !settings || !settings.loan || !settings.loan.sidebar || !settings.loan.sidebar.paShowStatus ) ) ? (
                                                l.stage
                                            ) : (
                                                l.status
                                            )
                                        }
                                        </Col>
                                        <Col>
                                            <Row className='align-items-center'>
                                                <Col xs='auto' className='tf-sidebar-obj-key-date-container'>
                                                    <span className='tf-sidebar-obj-key-date'>
                                                        <Link to={`/loan/${l.lid}`}>{l.name}</Link>
                                                    </span>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col className='tf-sidebar-obj-desc'>
                                                    {l.stage} - ${formatShorthand( l.amount )} - {l.purpose}
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col xs='auto'><FaRegTrashAlt className='tf-sidebar-trash' onClick={ () => trash( l.aid, l.lid ) } /></Col>
                                    </Row>
                                </ListGroup.Item>
                            )
                        } )
                    }
                    </ListGroup>
                </AccordionDetails>
            </Accordion>
        </Container>
    )
}

const mapProps = ( state ) => ( {
    aid: state.user.aid,
    uid: state.user.email,
    settings: state.user.meta.settings
} );

const mapDispatch = ( dispatch ) => ( {
    // loadTasks: dispatch.contacts.loadContactTasks,
} );

export default connect( mapProps, mapDispatch )( Loans );